<section class="header">
  <!-- Botão Criar Grupo sempre visível -->
  <div class="flex justify-content-end mb-3">
    <button type="button" class="btn btn-sm btn-primary" (click)="addGroup()">
      <i data-feather="plus"></i>Adicionar Grupo
    </button>
  </div>
</section>

<section class="section-groups" [formGroup]="formGroup">
  <div class="position-relative">
    <!-- 🔒 Block UI Overlay -->
    <div class="block-ui-overlay" *ngIf="isRemoving">
      <div class="text-center">
        <div class="spinner-border text-primary mb-2" role="status"></div>
        <div>Removendo elemento...</div>
      </div>
    </div>
    
    <div formArrayName="groups">
      <!-- Se não houver grupos -->
      <div *ngIf="groupsControls.length === 0" class="flex flex-column align-items-center justify-content-center py-5">
        <span class="text-muted mb-3">Nenhum grupo de inputs criado.</span>
      </div>

      <!-- Se houver grupos -->
      <ngb-accordion *ngIf="groupsControls.length > 0" [closeOthers]="false" [destroyOnHide]="false"
        #acc="ngbAccordion">
        <ng-container *ngFor="let control of groupsControls; let i = index">
          <ngb-panel [id]="'group-' + i" [formGroupName]="i" [cardClass]="'card-fit'">
            <ng-template ngbPanelTitle>
              <div class="flex align-items-center">
                <div class="flex flex-1 align-items-center gap-4">
                  <span>{{ getGroupLabel(control, i) }}</span>
                </div>
                <div class="flex">
                  <button type="button" class="btn btn-flat btn-icon text-danger"
                    (click)="removeGroup(i); $event.stopPropagation()">
                    <i data-feather="trash-2"></i>
                  </button>
                  <button type="button" class="btn btn-flat btn-icon" (click)="moveGroupUp(i); $event.stopPropagation()"
                    [disabled]="i === 0">
                    <i data-feather="arrow-up"></i>
                  </button>
                  <button type="button" class="btn btn-flat btn-icon"
                    (click)="moveGroupDown(i); $event.stopPropagation()" [disabled]="i === groupsControls.length - 1">
                    <i data-feather="arrow-down"></i>
                  </button>
                </div>
              </div>
            </ng-template>

            <ng-template ngbPanelContent>
              <div class="form-group">
                <label>Nome do Grupo:</label>
                <input class="form-control" formControlName="label" />
              </div>

              <label>Perguntas/Inputs</label>
              <div class="form-group">
                <ul class="list-group list-items" cdkDropList [cdkDropListData]="getItensControls(control)"
                  (cdkDropListDropped)="onDropItem($event, control)" [class.drag-active]="dragActive">
                  <ng-container *ngIf="hasItemsInGroup(control); else emptyQuestions">
                    <ng-container *ngFor="let itemControl of getItensControls(control)">
                      <li class="list-group-item flex align-items-center" [ngClass]="{
                          'father-item': !isChildItem(itemControl),
                          'child-item': isChildItem(itemControl),
                          dragging: dragActive
                        }" cdkDrag [cdkDragDisabled]="isChildItem(itemControl)" (cdkDragStarted)="dragActive = true"
                        (cdkDragEnded)="dragActive = false" cdkDragHandle>
                        <i *ngIf="isChildItem(itemControl)" data-feather="corner-down-right"></i>
                        <i *ngIf="!isChildItem(itemControl)" data-feather="move"></i>

                        <div class="flex flex-1 flex-column ml-1">
                          <span>{{ getItemLabel(itemControl) }}</span>
                          <small class="text-secondary">{{
                            getItemDescription(itemControl)
                            }}</small>
                        </div>

                        <button type="button" class="btn btn-icon" (click)="
                            handleCreateOrUpdateQuestionItem(control, itemControl)
                          ">
                          <i data-feather="edit"></i>
                        </button>
                        <button type="button" class="btn btn-icon text-danger ml-1"
                          (click)="removeItem(control, itemControl)">
                          <i data-feather="trash-2"></i>
                        </button>
                      </li>
                    </ng-container>
                  </ng-container>
                </ul>

                <div class="flex">
                  <button type="button" class="btn btn-sm btn-flat-secondary w-auto mx-auto mt-2"
                    (click)="handleCreateOrUpdateQuestionItem(control)">
                    Adicionar
                  </button>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ng-container>
      </ngb-accordion>
    </div>
  </div>
</section>

<!-- Template para lista de perguntas vazia -->
<ng-template #emptyQuestions>
  <div class="flex flex-column align-items-center justify-content-center gap-4 mt-1">
    <span>Não há perguntas/inputs adicionados.</span>
  </div>
</ng-template>